import { Money } from "classes/DecimalClasses";

import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/company/accountInfo/schema";
import { transformFields } from "services/utility/afterGet";

import { SOS_BILLING_CURRENCY_CODE } from "appConstants";

export function afterGet(record) {
  record.currency = { name: SOS_BILLING_CURRENCY_CODE };
  const newRecord = transformFields(record, FIELDS_TO_TRANSFORM);

  // currency is only used in conjuction with transformFields to set the USD currency code for Money fields
  delete newRecord.currency;

  newRecord.plan.extraUserMonthlyPrice = new Money(
    record.plan.extraUserMonthlyPrice
  );

  return newRecord;
}
